import { Reveal, RevealText } from "./Reveal";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1758520145408-dedb359d1c49?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjBvZmZpY2UlMjB0ZWFtJTIwZGFya3xlbnwwfHx8fDE3NzY3NjUwNzN8MA&ixlib=rb-4.1.0&q=85";

export const About = () => {
  return (
    <section
      id="about"
      className="relative py-20 md:py-28 bg-[var(--bb-bg)]"
      data-testid="about-section"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <Reveal>
          <div className="flex items-baseline justify-between mb-12">
            <div className="mono-label">[ 03 / Sobre Nosotros ]</div>
            <div className="hidden md:block font-mono text-xs text-[var(--bb-muted)]">
              EST. MADRID · ES
            </div>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-7">
            <h2 className="font-display text-[12vw] md:text-[7vw] leading-[0.95] tracking-[-0.03em] text-[var(--bb-text)] mb-10">
              <RevealText text="Fundados por" />
              <br />
              <span className="font-serif-italic text-[var(--bb-copper-light)]">
                <RevealText text="Pioneros." delay={0.3} />
              </span>
            </h2>

            <Reveal delay={0.3}>
              <p className="text-lg md:text-xl font-body leading-relaxed text-[var(--bb-text-2)] max-w-xl mb-8">
                Fundada por pioneros en la implementación de proyectos de IA a
                gran escala en España,{" "}
                <span className="text-[var(--bb-text)]">
                  Black Belts Consulting
                </span>{" "}
                nace de la pasión por transformar datos en decisiones
                estratégicas.
              </p>
              <p className="text-base md:text-lg font-body leading-relaxed text-[var(--bb-text-2)] max-w-xl">
                Nuestro equipo combina una profunda experiencia técnica con una
                visión de negocio para crear soluciones que no solo son
                tecnológicamente avanzadas, sino también increíblemente
                efectivas.
              </p>
            </Reveal>

            <Reveal delay={0.55}>
              <div className="mt-16 grid grid-cols-3 gap-6 max-w-lg">
                <Stat k="12+" v="Años · IA Enterprise" />
                <Stat k="80M+" v="Parámetros Desplegados" />
                <Stat k="ES" v="Fundado en España" />
              </div>
            </Reveal>
          </div>

          <div className="md:col-span-5">
            <Reveal delay={0.2}>
              <div className="relative overflow-hidden border border-[var(--bb-border-strong)] aspect-[3/4]">
                <div
                  className="absolute inset-0 bg-center bg-cover"
                  style={{
                    backgroundImage: `url(${ABOUT_IMG})`,
                    filter: "grayscale(100%) contrast(1.15) brightness(0.55)",
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[var(--bb-bg)] via-transparent to-transparent" />
                <div className="absolute top-4 left-4 mono-label text-[var(--bb-copper-light)]">
                  ENSAYO · 2025
                </div>
                <div className="absolute bottom-6 left-6 right-6">
                  <div className="mono-label mb-2">NUESTRA MISIÓN</div>
                  <p className="font-serif-italic text-xl md:text-2xl leading-snug text-[var(--bb-text)]">
                    “Desarrollar soluciones de IA innovadoras y personalizadas
                    que generen un valor medible y sostenible.”
                  </p>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

const Stat = ({ k, v }) => (
  <div className="border-t border-[var(--bb-border-strong)] pt-4">
    <div className="font-display text-3xl md:text-4xl text-[var(--bb-text)] mb-2">
      {k}
    </div>
    <div className="mono-label text-[10px]">{v}</div>
  </div>
);
